// store/toastStore.ts
import { create } from "zustand";

type ToastSeverity = "success" | "info" | "warn" | "error";

interface ToastState {
  isVisible: boolean;
  severity: ToastSeverity;
  summary: string;
  detail: string;
  showToast: (severity: ToastSeverity, summary: string, detail: string) => void;
  hideToast: () => void;
  addToast: (props: {
    severity: ToastSeverity;
    summary?: string;
    detail: string;
  }) => void;
}

export const useToastStore = create<ToastState>((set) => ({
  isVisible: false,
  severity: "info",
  summary: "",
  detail: "",
  addToast: (props: {
    severity: ToastSeverity;
    summary?: string;
    detail: string;
  }) => set({ isVisible: true, ...props }),
  showToast: (severity, summary, detail) =>
    set({ isVisible: true, severity, summary, detail }),
  hideToast: () => set({ isVisible: false, summary: "", detail: "" }),
}));
